module.exports = __webpack_public_path__ + "img/banner.085450fd.jpg";